import { render, staticRenderFns } from "./ResizeIcon.vue?vue&type=template&id=158cd0d8&"
import script from "./ResizeIcon.vue?vue&type=script&lang=js&"
export * from "./ResizeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports